import templateUrl from './visibleHoursPicker.html';

export default {
  controllerProvider: async () =>
    (await import(/* webpackChunkName: "settings" */ './visibleHoursPickerComponentCtrl')).default,
  bindings: {
    visibleStart: '<',
    visibleEnd: '<',
    onUpdate: '&',
    isDisabled: '<',
  },
  controllerAs: 'ctrl',
  templateUrl,
};
